import { ProductPageData } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
import { ProductVariantWithDescription } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Product'

const REPLACEMENT_MAP = {
  '"': '\\"',
  "'": "\\'",
  '`': '\\`',
}
const TAG_CHARACTER_REGEX = /<[^<>]*>|[\n]/g
const SPECIAL_CHARACTER_REGEX = /[&"!'\\`]/g

export const productContentSanitize = (content: string) => {
  let sanitizedString = content

  if (TAG_CHARACTER_REGEX.test(sanitizedString)) {
    sanitizedString = sanitizedString.replace(TAG_CHARACTER_REGEX, '')
  }

  if (SPECIAL_CHARACTER_REGEX.test(sanitizedString)) {
    sanitizedString = sanitizedString.replace(
      SPECIAL_CHARACTER_REGEX,
      (match) => REPLACEMENT_MAP[match] || match,
    )
  }

  return sanitizedString
}

export const getProductFeed = (
  selectedVariant: ProductVariantWithDescription,
  product: ProductPageData,
  powerReviewGroups?: string,
) => {
  const categoryName =
    (selectedVariant.breadcrumbs ?? product.breadcrumbs)
      ?.map((breadcrumb) => breadcrumb.text)
      .filter((text, index) => !(index === 0 && text === 'Home'))
      .join(' > ') ?? ''

  const variants = powerReviewGroups
    ? product.variants?.map((variant) => ({
        name: productContentSanitize(variant.title),
        image_url: variant.images[0]?.largeProduct || '',
        upc: variant?.barcode || '',
        page_id_variant: variant.sku,
      })) || []
    : []

  return {
    name: productContentSanitize(selectedVariant.title),
    url: selectedVariant.product?.url || product.url,
    description: productContentSanitize(
      selectedVariant.product?.description?.items[0]?.content || '',
    ),
    image_url:
      selectedVariant.images[0]?.largeProduct ||
      product.images[0]?.largeProduct,
    brand_name: productContentSanitize(
      selectedVariant.product?.brand?.name || '',
    ),
    upc: selectedVariant?.barcode || '',
    price: selectedVariant.price?.price.amount || '',
    category_name: productContentSanitize(categoryName),
    in_stock: selectedVariant.inStock?.toString() || '',
    ...(powerReviewGroups && { variants }),
  }
}
